import { defineStore } from "pinia";
import { useUser } from "@/stores/user/user";
import AUTH_API from "@/api/classes/auth";

export const useGuest = defineStore("guest", () => {
  const email = "test@gmail.com";
  const password = "test_password";

  const authLikeGuest = async () => {
    try {
      const userStore = useUser();
      const response = await AUTH_API.postLogin(email, password);

      if (response.status === 200) {
        if (userStore.user) {
          userStore.user.roles = ["guest"];
          userStore.token = null;
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  return { authLikeGuest };
});
